<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<p *ngIf="shortCodeList.length === 0">{{getEmptyListMessage() | async}}</p>

<p-table #tt id="tt" styleClass="p-datatable-striped" [value]="shortCodeList" dataKey="scId" *ngIf="shortCodeList.length !== 0" [paginator]="true" [rows]="100"
  [globalFilterFields]="['scId']" [filterDelay]="0" sortMode="single" [defaultSortOrder]="1" sortField="scExpirationDate" [alwaysShowPaginator]="false"
  (onFilter)="tableFiltered($event)" (sortFunction)="customSort($event)" [customSort]="true" currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})"
  [showCurrentPageReport]="true" (onPage)="jumpToTop()" [showInitialSortBadge]="false" [scrollable]="true" scrollHeight="50vh">
  <!-- Template paginatorright as a hacky way to add spacing. DO NOT REMOVE!!! -->
  <ng-template pTemplate="paginatorright" let-state></ng-template>
  <ng-template pTemplate="caption">
    <div class="row" *ngIf="shortCodeList.length !== 0">
      <div class="col-4">
        <form class="search-bar-form" style="width: 100%;">
          <input *ngIf="!checked" appAlphaNumOnly maxlength="6" type="text" class="search-bar-input" #globalSearch name="globalSearch" placeholder="Search"
            [(ngModel)]="shortCodeSearchInput" (input)="tt.filterGlobal(shortCodeToNumeric($any($event.target).value), 'contains')" pattern=".*[0-9].*">
          <input *ngIf="checked" appNumericOnly maxlength="20" type="text" class="search-bar-input" #globalSearch name="globalSearch" placeholder="Search"
            [(ngModel)]="orderSearchInput" (input)="tt.filterGlobal($any($event.target).value, 'contains')" pattern=".*[0-9].*">
          <!-- Commenting Button just incase we need in future. -->
          <!-- <button class="search-bar-button"  (submit)="tt.filterGlobal($any($event.target).value, 'contains')" ><i class="fas fa-magnifying-glass"></i></button>  -->
        </form>
      </div>
      <div class="col-4 d-flex justify-content-center search-slider-box">
        <span [ngClass]="{'opacity': checked}" class="slider-text me-2">Short Code</span>
        <p-inputSwitch [(ngModel)]="checked" (onChange)="onSlide()" name="SCONSlider" id="SCONSlider">
        </p-inputSwitch>
        <span [ngClass]="{'opacity': !checked}" class="slider-text ms-2">Order ID</span>
      </div>
      <div class="col-4 justify-content-center filter-button-box">
        <div class="center-horizontally-and-vertically ">
          <button class="btn btn-primary me-2" (click)="toggleFilter();" id="shoHideBtn">{{filtersVisible ? "Hide Filters" : "Show Filters"}}</button>
          <button *ngIf="filtersVisible" class="btn btn-secondary" (click)="clearFilter()" id="clearBtn">Clear Filters</button>
        </div>
      </div>
    </div>
    <div class="row mt-4" *ngIf="shortCodeList.length !== 0 && (listMode === 'needsaction') && isNotCarrierRegistrant">
      <div class="col-auto mt-3 mb-3">
        <button i18n class="btn btn-primary" [disabled]="bulkSelectionCount<2" (click)="doBulkRenew()" id="doBulkRenew">Renew Selected Short Codes</button>
        <span class="ms-2">({{bulkSelectionCount}} short codes selected. You may select a maximum of 20 short codes to renew at once.)</span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-shortCode>
    <tr class="mt-3">
      <th class="small-column-flex-override"></th>
      <th *ngIf="(listMode === 'needsaction') && isNotCarrierRegistrant">Select ({{bulkSelectionCount}})</th>
      <th [pSortableColumn]="'scId'" sortOrder="asc">
        <div class="d-flex justify-content-start align-items-center">
          Short Code
          <p-sortIcon [field]="'scId'"></p-sortIcon>
        </div>
      </th>
      <th *ngIf="listMode && listMode.startsWith('linkedaccounts')" [pSortableColumn]="'linkedAccountName'" sortOrder="asc" sortPriority="1">
        <div class="d-flex justify-content-start align-items-center">
          Account Name
          <i *ngIf="filterKeys.includes('linkedAccountName')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
          <p-sortIcon [field]="'linkedAccountName'"></p-sortIcon>
        </div>
      </th>
      <th [pSortableColumn]="'scExpirationDate'" sortOrder="asc" sortPriority="1">
        <div class="d-flex justify-content-start align-items-center">
          Expiration Date
          <p-sortIcon [field]="'scExpirationDate'"></p-sortIcon>
        </div>
      </th>
      <th [pSortableColumn]="'leaseStatus'">
        <div class="d-flex justify-content-start align-items-center">
          Status
          <i *ngIf="filterKeys.includes('leaseStatus')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
          <p-sortIcon [field]="'leaseStatus'"></p-sortIcon>
        </div>
      </th>
      <th [pSortableColumn]="'term'">
        <div class="d-flex justify-content-start align-items-center">
          Term
          <i *ngIf="filterKeys.includes('term')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
          <p-sortIcon [field]="'term'"></p-sortIcon>
        </div>
      </th>

      <th [pSortableColumn]="'orderId'">
        <div class="d-flex justify-content-start align-items-center">
          Order ID
          <p-sortIcon [field]="'orderId'"> </p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="autorenew">
        <div class="d-flex justify-content-start align-items-center">
          Auto-Renew
          <i *ngIf="filterKeys.includes('autorenew')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
          <p-sortIcon field="autorenew"></p-sortIcon>
        </div>
      </th>
      <th>
        <div class="d-flex justify-content-start align-items-center">
          Action
        </div>
      </th>
    </tr>
    <tr *ngIf="filtersVisible">
      <th class="small-column-flex-override"></th>
      <th *ngIf="listMode === 'needsaction' && isNotCarrierRegistrant" class="list-header-filter"></th>
      <th class="list-header-filter"></th>
      <th *ngIf="listMode && listMode.startsWith('linkedaccounts')" class="list-header-filter">
        <p-columnFilter #linkedAccountNameFilter id="linkedAccountNameFilter" field="linkedAccountName" [showMenu]="false" matchMode="contains" type="text"
          placeholder="Enter Account Name">

        </p-columnFilter>
      </th>
      <th class="list-header-filter"></th>
      <th class="list-header-filter">
        <p-columnFilter #leaseStatusFil id="leaseStatusFil" field="leaseStatus" matchMode="in" [showMenu]="false">
          <ng-template pTemplate="filter" let-leaseStatusFilter let-filterStatus="filterCallback">
            <p-multiSelect id="multiLeaseStatus" appTid [ngModel]="leaseStatusFilter" [options]="allLeaseStatus" appendTo="body" placeholder="Select" appendTo="body"
              (onChange)="filterStatus($event.value)" optionLabel="label" optionValue="value" selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>
      <th class="list-header-filter">
        <p-columnFilter #termFil id="termFil" field="term" matchMode="in" [showMenu]="false">
          <ng-template pTemplate="filter" let-termsFilter let-filterTerm="filterCallback">
            <p-multiSelect id="multiTerm" appTid [ngModel]="termsFilter" [options]="allTerms" placeholder="Select" appendTo="body" (onChange)="filterTerm($event.value)"
              optionLabel="label" optionValue="value" selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2" appendTo="body">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>
      <th class="list-header-filter"></th>
      <th class="list-header-filter">
        <p-columnFilter #autorenewFil id="autorenewFil" field="autorenew" matchMode="in" [showMenu]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
          *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
          <ng-template pTemplate="filter" let-autorenewFilter let-filterAutorenew="filterCallback">
            <p-multiSelect id="multiAutorenew" appTid selectedItemsLabel="{0} items selected" [ngModel]="autorenewFilter" [options]="allAutorenew" placeholder="Select"
              appendTo="body" (onChange)="filterAutorenew($event.value)" optionLabel="label" optionValue="value" [maxSelectedLabels]="2">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>
      <th class="list-header-filter"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-shortCode let-expanded="expanded">
    <tr id="row_{{shortCode.scId}}">
      <td class="small-column-flex-override">
        <button type="button" (click)="getShortCodeDetails(shortCode.scId)" pButton pRipple [pRowToggler]="shortCode" class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'fas fa-minus' : 'fas fa-plus'">
        </button>
      </td>
      @if (listMode === 'needsaction' && isNotCarrierRegistrant) {
      <td>
        @if (shortCode.settings.label ==='Renew' && !shortCode.parkedCode) {
        <p-checkbox class="bulk-checkbox" name="bulkcheck" value="{{shortCode.leaseId}}" (click)="bulkChecked(shortCode.leaseId)" [(ngModel)]="bulk"></p-checkbox>
        }
      </td>
      }
      <td>{{shortCode.scId}}</td>

      <td style="max-width: 50px;" *ngIf="listMode && listMode.startsWith('linkedaccounts')" class="truncate" [pTooltip]="shortCode.linkedAccountName" tooltipPosition="top"
        appShowToolTipIfTruncated>
        {{shortCode.linkedAccountName}}
      </td>



      <td>{{shortCode.scExpirationDate | date:'M/d/yyyy' }}</td>
      <td [ngStyle]="{'color': shortCode.leaseStatus.startsWith('Cancelled') ? '#FF0000' : ''}">
        {{shortCode.leaseStatusXm}}</td>
      <td>{{shortCode.termXm }}</td>
      <td>
        <a class="link" style="cursor: pointer;" (click)="navigateToOrder(shortCode.accountId, shortCode.orderId)">
          {{ shortCode.orderId }}
        </a>
      </td>
      <td>{{shortCode.autorenew | scrConfig:'autorenew' }}</td>
      <td>
        @if (shortCode.settings.showButton) {
        <button (click)="doAction(shortCode)" class="btn btn-primary btn-sm">{{shortCode.settings.label}}</button>
        }
      </td>

    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-shortCode>
    <tr *ngIf="shortCode.details" style="width: 99%;">
      <td colspan="10">
        <div class="row panel-margin">
          <div class="col-4">
            <div class="ms-0 mb-1">
              <strong>Start Date: </strong>&nbsp; {{ shortCode.details.lease.startDate | date: 'M/d/yyyy' }}
              {{ shortCode.details.lease.startDate ? '' : 'Pending' }}
            </div>
            <div class="ms-0 mb-1">
              <strong>End Date: </strong>&nbsp; {{ shortCode.details.lease.endDate | date: 'M/d/yyyy' }}
              {{ shortCode.details.lease.endDate ? '' : 'Pending' }}
            </div>
            <div class="ms-0 mb-1">
              <strong>Short Code Type: </strong>&nbsp; {{ shortCode.details.lease.selectType }}
            </div>
            <div class="ms-0 mb-1">
              <strong> Application Type:</strong>&nbsp; {{ shortCode.details.lease.applicationType }}
            </div>
            <div class="ms-0 mb-1">
              <strong> Previous Order:</strong>
              &nbsp;
              <a class="link ms-1" (click)="navigateToOrder(shortCode.accountId, shortCode.details.lease.parentOrderId, true)">{{shortCode.details.lease.parentOrderId}}</a>
            </div>
            <div class="ms-0 mb-1" *ngIf="!linkedAccountMode && shortCode.details.lease.registryComments">
              <a class="link" (click)="registryComments = shortCode.details.lease.registryComments; showRegistryComments = true;">
                Registry Comments
              </a>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-1">
              <strong>CSC Registrant Name:</strong>&nbsp; {{ shortCode.details.lease.firstName }} {{
              shortCode.details.lease.lastName }}
            </div>
            <div class="mb-1">
              <strong>Billing Contact Name: </strong>&nbsp; {{ shortCode.details.lease.billingFirstName }} {{
              shortCode.details.lease.billingLastName }}
            </div>

            <div *ngIf="brandsEnabled" class="mb-1">
              <strong>Brand Client(s): </strong>&nbsp;
              @if (shortCode.details.lease.parkedCode) {
              N/A - Parked Code
              }
              @else if (shortCode.details.lease.demoCode) {
              N/A - Demo Code
              }
              @else if (shortCode.details.lease.brands && shortCode.details.lease.brands.length === 0) {
              No associated Brand Clients
              }
              @else if (shortCode.details.lease.brands && shortCode.details.lease.brands.length === 1) {
              {{ shortCode.details.lease.brands[0].company }}
              }
              @else if (shortCode.details.lease.brands && shortCode.details.lease.brands.length > 1) {
              <a href="javascript:void()" (click)="toggleBrandNames(shortCode)">{{shortCode.details.lease.brands.length}} Brand Clients</a>
              }
            </div>
            <div *ngIf="!brandsEnabled" class="mb-1">
              <strong>Intended Usage: </strong>&nbsp;
              @if (shortCode.details.lease.parkedCode) { Parked Code }
              @else if (shortCode.details.lease.demoCode) { Demo Code }
              @else { Active Code }
            </div>


            <div class="mb-1">
              <strong>Content Provider: </strong>&nbsp;

              <div class="d-inline truncate w-50" [pTooltip]="shortCode.details.lease.contentProvider? shortCode.details.lease.contentProvider.company : ''" tooltipPosition="top"
                appShowToolTipIfTruncated>{{shortCode.details.lease.contentProvider?.company}}</div>
            </div>

            <div class="mb-1">
              <strong> Direct Connection Aggregator: </strong>&nbsp; {{ shortCode.details.lease.aggregator?.name }}
            </div>
            <div class="mb-1">
              <strong> Application Service Provider:</strong>&nbsp; <div class="d-inline truncate w-50"
                [pTooltip]="shortCode.details.lease.applicationProvider? shortCode.details.lease.applicationProvider : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{
                shortCode.details.lease.applicationProvider}}</div>
            </div>
            <ng-template [ngIf]="shortCode.details.lease.forPoliticalCampaign">
              <div class="mb-1">
                <strong> Used for Political Campaign: </strong>&nbsp;
                {{ shortCode.details.lease.forPoliticalCampaign ? 'Yes' : 'No' }}
              </div>
              <div class="mb-1">
                <strong> Political Campaign Status: </strong>&nbsp;
                {{shortCode.details.lease.politicalCampaignStatus}}
              </div>
              <div class="mb-1">
                <strong> Campaign Type: </strong>&nbsp;
                {{shortCode.details.lease.politicalCampaignType}}
              </div>
              <div class="mb-1">
                <strong> FEC ID: </strong>&nbsp;
                {{ shortCode.details.lease.fecId }}
              </div>
              <div class="truncate mb-1" style="max-width: 400px" [pTooltip]="shortCode.details.lease.politicalCampaignInfo" tooltipPosition="top" appShowToolTipIfTruncated>
                <strong> Other Campaign Info: </strong>{{ shortCode.details.lease.politicalCampaignInfo }}
              </div>
            </ng-template>
            <div *ngIf="!linkedAccountMode" class="mb-1">
              <a class="link" (click)="editDetails(shortCode)">
                Edit Application Details
              </a>
            </div>
            <div *ngIf="!linkedAccountMode" class="mb-1">
              <a class="link" (click)="editBillingDetails(shortCode)">
                Edit Billing Details
              </a>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-1"
              *ngIf="(shortCode.leaseType === 'Prepay' || shortCode.leaseType === 'FreeCarrierCode') && shortCode.details.lease.billingOrder.invoiceDocumentId && !shortCode.details.lease.mbOptOutDate">
              <a class="link" (click)="viewInvoice(shortCode.scId, shortCode.accountId, shortCode.orderId, shortCode.details.lease.billingOrder.paymentId)">
                View Invoice
              </a>
            </div>
            <div class="mb-1"
              *ngIf="(shortCode.leaseType === 'Prepay' || shortCode.leaseType === 'FreeCarrierCode') && shortCode.details.lease.billingOrder.receiptDocumentId && shortCode.details.lease.billingOrder.paymentId">
              <a class="link" (click)="viewPaymentReceipt($event, shortCode.accountId, shortCode.details.lease.billingOrder.paymentId)">
                View Receipt
              </a>
            </div>
            <div class="mb-1"
              *ngIf="(shortCode.leaseType === 'Prepay' || shortCode.leaseType === 'FreeCarrierCode') && shortCode.details.lease.billingOrder.receiptDocumentId && !shortCode.details.lease.billingOrder.paymentId">
              <a class="link" (click)="viewReceipt($event, shortCode.accountId, shortCode.orderId)">
                View Receipt
              </a>
            </div>
            <div class="mb-1" *ngIf="( shortCode.leaseType === 'BilledMonthly' || shortCode.details.lease.mbOptOutDate ) && shortCode.details.monthlyInvoiceDocumentId ">
              <a class="link" (click)="viewInvoice(shortCode.scId, shortCode.accountId, shortCode.details.monthlyInvoiceId, shortCode.details.lease.billingOrder.paymentId)">
                View Monthly Invoice
              </a>
            </div>
            <div class="mb-1" *ngIf="(shortCode.leaseType === 'BilledMonthly' || shortCode.details.lease.mbOptOutDate ) && shortCode.details.monthlyReceiptDocumentId">
              <a class="link" (click)="viewReceipt($event, shortCode.accountId, shortCode.details.monthlyInvoiceId)">
                View Monthly Receipt
              </a>
            </div>
            <div class="mb-1" *ngIf="canViewIndividualShortCodeReceipt(shortCode)">
              <a class="link" (click)="clickIndividualReceiptButton(shortCode.accountId, shortCode.details.monthlyReceiptDocumentId,
                                shortCode.details.monthlyInvoiceId, shortCode.details.parentMonthlyInvoiceId, shortCode.scId)">
                View Individual Short Code Receipt
              </a>
            </div>
            <div class="mb-1" *ngIf="canViewPreviousPrepaidInvoice(shortCode)">
              <a class="link" (click)="viewPreviousPrepaidInvoice($event, shortCode.accountId, shortCode.details.lease.parentOrderId, shortCode.details.parentPaymentId)">
                View Previous Prepaid Invoice
              </a>
            </div>
            <div class="mb-1" *ngIf="canViewPreviousPrepaidReceipt(shortCode)">
              <a class="link" (click)="viewPreviousPrepaidReceipt($event, shortCode.accountId, shortCode.details.lease.parentOrderId)">
                View Previous Prepaid Receipt
              </a>
            </div>
            <div class="mb-1" *ngIf="shortCode.leaseType === 'BilledMonthly' || shortCode.details.lease.mbOptOutDate">
              <a class="link" (click)="viewMonthlyBillingEnrollmentStatement($event, shortCode.accountId, shortCode.details.lease.orderId)">
                View Monthly Billing Enrollment Statement
              </a>
            </div>
            <div class="mb-1" *ngIf="!linkedAccountMode && shortCode.leaseType !== 'FreeCarrierCode' && shortCode.details.lease.orderSource === 'Transferred'">
              <a class="link" (click)="downloadTransferStatement(shortCode)">
                Download Transfer Statement
              </a>
            </div>
            <div class="mb-1" *ngIf="shortCode.leaseType !== 'BilledMonthly' && isNotCarrierRegistrant">
              <label for='mbood' *ngIf="shortCode.details.lease.mbOptOutDate"> <strong id='mbood'>Monthly Billing Opt Out Date: </strong> {{shortCode.details.lease.mbOptOutDate |
                date:
                'M/d/yyyy'}}
              </label>
            </div>
            <div class="row"></div>
            <div class="d-inline" *ngIf="!linkedAccountMode && shortCode.leaseType !== 'BilledMonthly' && isNotCarrierRegistrant ">
              <div class="align-middle">
                <strong class="me-3 align-top">Auto-Renew:</strong>
                <span [ngClass]="{'opacity': shortCode.autorenew}" class="me-2 align-top slider-text">Opt Out</span>
                <p-inputSwitch [id]="'autorenewToggle'+shortCode.scId" [(ngModel)]="shortCode.autorenew" name="autorenew" (onChange)="autorenewToggled(shortCode)"
                  [disabled]="blockAutoRenew(shortCode) || linkedAccountMode">
                </p-inputSwitch>
                <span [ngClass]="{'opacity': !shortCode.autorenew}" class="ms-2 align-top slider-text">Opt In</span>
              </div>
            </div>
            <div class="row mb-3" *ngIf="shortCode.leaseType !== 'BilledMonthly' && !linkedAccountMode">
              <p-checkbox [(ngModel)]="shortCode.details.lease.suppressExpiryEmail" [disabled]="shortCode.autorenew" label="Don't Send Renewal Reminder Emails" [binary]="true"
                [id]="'suppressEmail'+shortCode.scId" [name]="'suppressEmail'+shortCode.scId" (onChange)="suppressEmail(shortCode)">
              </p-checkbox>
            </div>
            <div class="mt-2" *ngIf="isNotCarrierRegistrant && !linkedAccountMode">
              <button
                *ngIf="shortCode.leaseStatus === 'Approved' &&  shortCode.details.transfer?.transferStatus!=='Pending' && shortCode.details.transfer?.transferStatus!=='Accepted'"
                class="col-auto btn btn-primary btn-sm me-4" (click)="showShortCodeTransferDialog(shortCode.scId)">Transfer Code</button>
              <button
                *ngIf="(!linkedAccountMode && (shortCode.leaseStatus === 'Approved' || shortCode.leaseStatus === 'Cancelled' || shortCode.leaseStatus === 'PendingRenew')  && ( shortCode.details.transfer?.transferStatus==='Pending' || shortCode.details.transfer?.transferStatus==='Accepted'  ))"
                class="col-auto btn btn-primary btn-sm me-4" disabled>{{shortCode.details.transfer?.transferStatus==='Accepted'?'Transfer
                Accepted':'Transfer Pending'}}</button>
              <button
                *ngIf="!linkedAccountMode && (shortCode.leaseStatus === 'Approved') || (shortCode.details.transfer?.transferStatus==='Pending' || shortCode.details.transfer?.transferStatus==='Accepted')"
                class="col-auto btn btn-primary btn-sm"
                [disabled]="(shortCode.details.transfer?.transferStatus!=='Pending' && shortCode.details.transfer?.transferStatus!=='Accepted'  )"
                (click)="doCancelTransfer(shortCode.scId,shortCode.details.transfer.toAccountId, shortCode.details.transfer.transferId)">Cancel
                Transfer</button>
            </div>
            <div *ngIf='!linkedAccountMode' class="mt-2">
              <button *ngIf="isNotCarrierRegistrant && shortCode.details.lease.leaseType === 'BilledMonthly'" class="col-auto btn btn-primary btn-sm me-4"
                (click)="doMbOptOut(shortCode)">Opt Out of Monthly Billing</button>
              <button *ngIf="shortCode.statusReason !== 'CancelRequested' &&(shortCode.leaseType === 'Prepay' || shortCode.leaseType === 'FreeCarrierCode')"
                class="col-auto btn btn-primary btn-sm me-4" (click)="showCancelLeaseDialog(shortCode)" id="cancelshortcodelease">Cancel Short Code Lease</button>
            </div>
          </div>
        </div>

      </td>
    </tr>
    <tr *ngIf="!shortCode.details && !detailsLoading">
      <td colspan="8">
        <div class="mt-5 mb-5 ms-5 me-5 d-grid">
          <button class="mx-auto btn btn-secondary" (click)="loadShortCodeDetails(shortCode.scId)">Reload Details</button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div *ngIf="activeModal === 'mb-opt-out' ">
  <app-common-mb-opt-out [scId]="mbOptOutSc" [leaseId]="mbOptOutLease || 0" [message]="optOutMsg" (update)="onUpdateOptOut($event)"></app-common-mb-opt-out>
</div>

<div *ngIf="activeModal === 'mb-opt-out-success' ">
  <app-common-mb-opt-out-success [expirationDate]="scExpirDate" [user]="mbOptOutUser" [scId]="mbOptOutSc" [message]="optOutMsg" [monthly_invoice_id]="mbOptOutMonthlyInvoiceId"
    [invoice_date]="mbOptOutInvoiceDate" (successUpdate)="onUpdateOptOutSuccess()"></app-common-mb-opt-out-success>
</div>

<p-confirmDialog key='setOptIn' #setOptIn width="425" [closable]="false">
  <p-footer>
    <button i18n id="scaccept" class="btn btn-primary me-2" (click)="setOptIn.accept()">OK</button>
    <button i18n id="screject" class="btn btn-secondary" (click)="setOptIn.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='setOptOut' #setOptOut width="425" [closable]="false">
  <p-footer>
    <button i18n id="scaccept" class="btn btn-primary me-2" (click)="setOptOut.accept()">OK</button>
    <button i18n id="screject" class="btn btn-secondary" (click)="setOptOut.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='confirmOptIn' #confirmOptIn width="425" [closable]="false">
  <p-footer>
    <button i18n id="screject" class="btn btn-primary" (click)="confirmOptIn.reject()">OK</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='confirmOptOut' #confirmOptOut width="425" [closable]="false">
  <p-footer>
    <button i18n id="screject" class="btn btn-primary" (click)="confirmOptOut.reject()">OK</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key='cancelTransfer' #cancelTransfer width="425" [closable]="false">
  <p-footer>
    <button i18n id="scaccept" class="btn btn-primary me-2" (click)="cancelTransfer.accept()">Yes</button>
    <button i18n id="screject" class="btn btn-secondary" (click)="cancelTransfer.reject()">No</button>
  </p-footer>
</p-confirmDialog>

<app-short-code-transfers-dialog [style]="{width: '40vw'}" [fromAccountID]="account.accountId" [scId]="transferCode" (transferCodeClick)="transferEventHandler($event)">
</app-short-code-transfers-dialog>


<p-confirmDialog key='loginAs' #loginAs [style]="{width: '35vw'}" [closable]="false">
  <p-footer>
    <button i18n id="login-as-accept" class="btn btn-primary me-2" (click)="loginAs.accept()">OK</button>
    <button i18n id="login-as-reject" class="btn btn-secondary" (click)="loginAs.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>



<app-cancel-shortcode-lease-confirmation-dialog [style]="{width: '40vw'}" [cancelScid]="cancelScid" [confirmationMessage]="confirmationMessage"
  [informationMessage]="informationMessage" [leaseStatus]="leaseStatus" [statusReason]="statusReason" [cancelScOrderId]="cancelScOrderId"
  (reLoadList)="reLoadShortCode(cancelScid)"></app-cancel-shortcode-lease-confirmation-dialog>

<p-dialog header="Registry Comments" [(visible)]="showRegistryComments" [modal]="true" [closable]="false" [draggable]="false"
  [contentStyle]="{ 'line-height': '1.5rem', 'max-height': '15rem' }">
  {{ registryComments }}
  <p-footer>
    <button class="btn btn-primary float-end" (click)="showRegistryComments = false">
      OK
    </button>
  </p-footer>
</p-dialog>

<p-dialog header="Brand Clients for short code {{ leaseForBrandClientDialog?.scId}} " [visible]="leaseForBrandClientDialog !== undefined" [modal]="true" [closable]="false"
  [draggable]="false" [contentStyle]="{ 'line-height': '1.5rem', 'max-height': '15rem' }">
  <ul class="list-unstyled">
    <li [ngStyle]="{'margin-top': isFirst ? '0px' : '5px'}" *ngFor="let item of leaseForBrandClientDialog?.details?.lease?.brands; first as isFirst">
      {{item.company}}
    </li>
  </ul>
  <p-footer>
    <button class="btn btn-primary float-end" (click)="leaseForBrandClientDialog = undefined">
      OK
    </button>
  </p-footer>
</p-dialog>

<p-dialog header="Bulk Renew Failed" [visible]="bulkRenewFailures !== undefined" [modal]="true" [closable]="false" [draggable]="false"
  [contentStyle]="{ 'line-height': '1.5rem', 'max-height': '20rem' }">
  <p>
    The selected short codes were not renewed, because the following short codes did not
    pass the mandatory vetting requirements.
  </p>
  <ul>
    <li [ngStyle]="{'margin-top': isFirst ? '0px' : '5px'}" *ngFor="let item of bulkRenewFailures; first as isFirst">
      {{item.message}}
    </li>
  </ul>
  <p>
    You can renew these short codes individually to review and update the information
    as needed on the Application tab of the Checkout page.
  </p>
  <p-footer>
    <button class="btn btn-primary float-end" (click)="bulkRenewFailures = undefined">
      OK
    </button>
  </p-footer>
</p-dialog>